<template>
  <HeadCont v-if="showHeadCont" />
  <HistoryCont v-if="showHeadCont && (userLoginInfo ? true : false)" />
  <!-- <a id="jumpBtn" class="btn" ref="jumpBtn"
    href="weixin://dl/business/?appid=wxd527590afb2dba01&path=pages/index/index&query=id%3D61bfc5138c0248b76bc875694da4f423">
    打开nfc
  </a> -->
  <router-view />
  <!-- <StaffServiceCont /> -->
</template>
<script setup>
import { onMounted, onBeforeMount, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useStore } from "@/store";
import { useRouter } from "vue-router";

const store = useStore();
const { userLoginInfo } = storeToRefs(store);
const { setUserLoginInfo } = store;
const baseApi = process.env.VUE_APP_BASE_API;
const router = useRouter();

// 需要隐藏 HeadCont 的路由列表
const hideHeadRoutes = ["wxGo", "demo"];

// 控制 HeadCont 显隐
const showHeadCont = ref(false);

// 判断当前路由是否需要显示 HeadCont
const checkHeadContShow = (route) => {
  showHeadCont.value = !hideHeadRoutes.includes(route.name);
};

const jumpBtn = ref(null);

onBeforeMount(() => {
  checkHeadContShow(router.currentRoute.value);
});

onMounted(() => {
  let loginUser = localStorage.getItem("loginUser");
  if (loginUser) {
    setUserLoginInfo(loginUser);
  }


  // document.getElementById("jumpBtn").click();
});

// 监听路由变化
watch(
  () => router.currentRoute.value,
  (newRoute) => {
    checkHeadContShow(newRoute);
  },
  { immediate: true },
);
</script>
<style lang="scss">
#webpack-dev-server-client-overlay {
  display: none !important;
}
</style>
